import React from 'react'
import WelcomeComp from '../../pages/Dashboard/WelcomeComp'
import {
    Row,
    Col,
    Card,
    CardBody,
    Media,
    CardTitle,
} from "reactstrap";
import { Link } from "react-router-dom";

const DashboardForBS = (props) => {
  return (
    <>
     <Row>
     <Col md="6">
                  <WelcomeComp />
                </Col>
                      <Col lg={12}>
                        <CardTitle>Finished Products</CardTitle>
                        <div
                          style={{
                            height: "90px",
                            overflowX: "hidden",
                            overflowY: "hidden",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <Link
                            to="/finished_products/add_order"
                            style={{ display: "inline-block" }}
                          >
                            <Card
                              className={
                                props.type === "new_orders"
                                  ? "mini-stats-wid bg-danger mr-4"
                                  : props.type === "orders_in_process"
                                    ? "mini-stats-wid bg-info mr-4"
                                    : "mini-stats-wid bg-success mr-4"
                              }
                              style={{ width: "180px" }}
                            >
                              <CardBody>
                                <Media>
                                  <Media body>
                                    {/* <p
                                className="fw-medium"
                                style={{ color: "white" }}
                              >
                                {section.section}
                              </p> */}
                                    <h5
                                      className="mb-0"
                                      style={{ color: "white" }}
                                    >
                                      Add New Order
                                    </h5>
                                  </Media>
                                </Media>
                              </CardBody>
                            </Card>
                          </Link>
                          <Link
                            to="/finished_products/all_orders"
                            style={{ display: "inline-block" }}
                          >
                            <Card
                              className={
                                props.type === "new_orders"
                                  ? "mini-stats-wid bg-danger mr-4"
                                  : props.type === "orders_in_process"
                                    ? "mini-stats-wid bg-info mr-4"
                                    : "mini-stats-wid bg-success mr-4"
                              }
                              style={{ width: "180px" }}
                            >
                              <CardBody>
                                <Media>
                                  <Media body>
                                    {/* <p
                                className="fw-medium"
                                style={{ color: "white" }}
                              >
                                {section.section}
                              </p> */}
                                    <h5
                                      className="mb-0"
                                      style={{ color: "white" }}
                                    >
                                      View All Order
                                    </h5>
                                  </Media>
                                </Media>
                              </CardBody>
                            </Card>
                          </Link>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <CardTitle>Items</CardTitle>
                        <div
                          style={{
                            height: "90px",
                            overflowX: "hidden",
                            overflowY: "hidden",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <Link
                            to="/items/add_order"
                            style={{ display: "inline-block" }}
                          >
                            <Card
                              className={
                                props.type === "new_orders"
                                  ? "mini-stats-wid bg-danger mr-4"
                                  : props.type === "orders_in_process"
                                    ? "mini-stats-wid bg-info mr-4"
                                    : "mini-stats-wid bg-success mr-4"
                              }
                              style={{ width: "180px" }}
                            >
                              <CardBody>
                                <Media>
                                  <Media body>
                                    {/* <p
                                className="fw-medium"
                                style={{ color: "white" }}
                              >
                                {section.section}
                              </p> */}
                                    <h5
                                      className="mb-0"
                                      style={{ color: "white" }}
                                    >
                                      Add New Order
                                    </h5>
                                  </Media>
                                </Media>
                              </CardBody>
                            </Card>
                          </Link>
                          <Link
                            to="/items/all_orders"
                            style={{ display: "inline-block" }}
                          >
                            <Card
                              className={
                                props.type === "new_orders"
                                  ? "mini-stats-wid bg-danger mr-4"
                                  : props.type === "orders_in_process"
                                    ? "mini-stats-wid bg-info mr-4"
                                    : "mini-stats-wid bg-success mr-4"
                              }
                              style={{ width: "180px" }}
                            >
                              <CardBody>
                                <Media>
                                  <Media body>
                                    {/* <p
                                className="fw-medium"
                                style={{ color: "white" }}
                              >
                                {section.section}
                              </p> */}
                                    <h5
                                      className="mb-0"
                                      style={{ color: "white" }}
                                    >
                                      View All Order
                                    </h5>
                                  </Media>
                                </Media>
                              </CardBody>
                            </Card>
                          </Link>
                        </div>
                      </Col>
                    </Row>
    </>
  )
}

export default DashboardForBS